import { Chip, ChipProps } from "@mui/material";

import { Program } from "@models/Program";

const ProgramStatusChip = ({
  program,
  ...props
}: { program: Program } & Partial<ChipProps>) => {
  const status =
    program.status === "draft"
      ? "Draft"
      : program.isActive
        ? "Active"
        : "Inactive";
  return (
    <Chip
      label={status}
      color={status === "Active" ? "info" : "default"}
      {...props}
    />
  );
};

export default ProgramStatusChip;
